const OptimizeService = {
    getVariant: (experimentId) => {
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({ event: "optimize.activate" });
        }

        return new Promise(resolve => {
            let intervalId = setInterval(() => {
                if (typeof window !== 'undefined' && window.google_optimize !== undefined) {
                    const variant = window.google_optimize.get(experimentId);
                    resolve(variant);
                    clearInterval(intervalId);
                }
            }, 100);
        });
    }
}

export default OptimizeService;
